import './NotFound.sass';
import img404 from '../assets/common/not-found.svg';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router';

const NotFound = () => {
	const [countDown, setCountDown] = useState(3);
	const history = useHistory();

	useEffect(() => {
		const interval = setInterval(() => {
			if (countDown) {
				setCountDown(countDown - 1);
			} else {
				history.push('/');
			}
		}, 1000);

		return () => {
			clearInterval(interval);
		};
	}, [countDown, history]);

	return (
		<div className='NotFound'>
			<div className='center-wrap'>
				<div className='image-wrap'>
					<img src={img404} alt='404' />
				</div>

				<div className='heading'>找不到頁面</div>
				<div className='details'>
					您點選的連結可能有誤或已被移除
					<br />
					請試試其他單元
				</div>
			</div>
		</div>
	);
};

export default NotFound;
